export const PaletteMode = {
    FILL: 0,  // 显示背景填充
    BORDER: 1, // 显示边框线段
    SIMPLE: 2, // 简单模式，只有调色板，无功能项
    EMPTY: 3, // 无功能项，无取色器
};
